export const DEFAULT_TIME_ZONE='Asia/Kolkata'